import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { Text, Title } from "../../../styles/Texts";
import { T } from "../../../styles/Theme";
import { DataContext } from "../../../contexts/DataContext";
import { AnswersContext } from "../../../contexts/AnswersContext";
import { ButtonStyled } from "../../../styles/Button";
import { CheckBoxGeneric } from "../../CheckBoxGeneric";
// import { completedForm, formScreenLoaded, policyAccepted, policyHasBeenReaded, skipContactForm } from "../../../utils/googleAnalytics";
import { CapturedDataGTM, EmailScreenUploadedGTM, PolicyAcceptedGTM, PolicyReadedGTM } from "../../../utils/GoogleTagManager";
import { getActivitiesToDo, getConectedDevicesAlternatives, getPlanSelected } from "../../../utils/common";

export const EmailScreen = () => {
  const termsAndConditions = (
    <>
    <p>
      <a href="https://www.entel.cl/legales/" onClick = {() => PolicyReadedGTM(window, getPlanSelected(finalForm), getActivitiesToDo(finalForm), getConectedDevicesAlternatives(finalForm))} target="_blank" rel="noreferrer">Acepto las políticas</a>, entregando consentimiento para
      uso de datos en campañas publicitarias y automatizaciones de
      Entel PCS Telecomunicaciones S.A y partners asociados.
      </p>
    </>
  )

  const [finalForm, , screenNumber, setScreenNumber] = useContext(DataContext);
  const [, setAnswers] = useContext(AnswersContext);
  const [email, setEmail] = useState("");
  const [checked, setChecked] = useState(false);
  const [phone, setPhone] = useState("");
  const [skipAvailable, setSkipAvailable] = useState(true);
  const [phoneWithouPrefix, setPhoneWithouPrefix] = useState("");

  useEffect(() => {
    verifyAnswers(finalForm);
    EmailScreenUploadedGTM(window, getPlanSelected(finalForm), getActivitiesToDo(finalForm), getConectedDevicesAlternatives(finalForm));
  },[])

  const acceptPolicy = () => {
    setChecked(!checked)
    PolicyAcceptedGTM(window, getPlanSelected(finalForm), getActivitiesToDo(finalForm), getConectedDevicesAlternatives(finalForm));
  }

  const verifyAnswers = (data: Array<any>) => {
    for(let i = 0; i < data.length; i++) {
      if (data[i].id_question === 2) {
        if (data[i].answer[3] === 1 || data[i].answer[4] === 1 ) {
          setSkipAvailable(false)
        }
      }

      if (data[i].id_question === 6 ) {
        if (data[i].answer[6] === 1 || data[i].answer[7] === 1 || data[i].answer[8] === 1) {
          setSkipAvailable(false)
        }
      }
    }
  }

  const checkEmailRegex = (email: string) => {
    // eslint-disable-next-line no-useless-escape
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(String(email).toLowerCase());
  }

  // const checkPhoneRegex = (phone: string) => {
  //   // eslint-disable-next-line no-useless-escape
  //   const regex = /^(\(\+?\d{2,3}\)[\*|\s|\-|\.]?(([\d][\*|\s|\-|\.]?){6})(([\d][\s|\-|\.]?){2})?|(\+?[\d][\s|\-|\.]?){8,9}(([\d][\s|\-|\.]?){2}(([\d][\s|\-|\.]?){2})?)?)$/
  //   return regex.test(String(phone).toLowerCase())
  // }

  const checkPhoneRegex = (phone: string) => {
    // eslint-disable-next-line no-useless-escape
    const regex = /^(\(\+?\d{1,3}\)[\s\-\.\*]?((\d[\s\-\.\*]?){6}(\d[\s\-\.\*]?){2})?|(\+?\d[\s\-\.\*]?){8,9}(\d[\s\-\.\*]?){2})$/
    return regex.test(String(phone).toLowerCase())
  }
  

  const nextScreen = () => {
    setScreenNumber(screenNumber + 1);
    // skipContactForm();
  }

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // completedForm();
    setAnswers({ email, phone });
    CapturedDataGTM(window, email, phone, getPlanSelected(finalForm), getActivitiesToDo(finalForm), getConectedDevicesAlternatives(finalForm));
    nextScreen();
  }

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    // if (input.startsWith("+569")) {
    //   setPhone(input);
    // }
    setPhoneWithouPrefix(input);
    setPhone("+569" + input);
  }

  return (
    <Container>
      <TitleStyled>
        Un último paso antes de continuar
        con la recomendación de productos
      </TitleStyled>
      <TextStyled>
        Ingresa tus datos y recibe promociones exclusivas
      </TextStyled>
      <br />
      <TextStyled>Correo electrónico</TextStyled>
      <form onSubmit={(e) => handleSubmit(e)}>
        <div className="inputContainer">
          <InputStyled
            placeholder="Email"
            autoFocus={true}
            onChange={(e) => setEmail(e.target.value)}
          />
        {(!checkEmailRegex(email)) && email !== "" && <p style={{"fontSize": 12, "color": "red", 'paddingBottom': '10px'}}>Por favor ingrese un email válido</p>}
        </div>
        <TextStyled>Teléfono</TextStyled>
        <div className="inputContainer">
          <PhoneContainer>
            <Prefix>+569</Prefix> 
            <InputStyledPhone
              placeholder = "12345678"
              maxLength={8}
              value={phoneWithouPrefix}
              onChange={handlePhoneChange}
            />
          </PhoneContainer>
          {(!checkPhoneRegex(phone)) && phoneWithouPrefix  && <p style={{"fontSize": 12, "color": "red", 'paddingBottom': '10px'}}>Por favor ingrese un teléfono válido</p>}
        </div>
        <div>
        <CheckBoxGeneric
          id={"termsAndConditions"}
          checked={checked}
          name={"termsAndConditions"}
          text={termsAndConditions}
          tag={""}
          onClick={() => acceptPolicy()}
        />
        </div>
        <br />
        <br />
        <div className="buttonContainer">
          <ButtonStyled
            bc={T.blue}
            c="white"
            disabled={!checkEmailRegex(email) || !checked || !checkPhoneRegex(phone)}
          >
            Quiero continuar
          </ButtonStyled>
        </div>
          <SkipContainer>
            {/* {skipAvailable && (<SkipStyled onClick={nextScreen}>Omitir</SkipStyled>)} */}
          </SkipContainer>
      </form>
    </Container>
  );
}

export default EmailScreen;

const TitleStyled = styled(Title)`
  margin: 30px 0 5px 0;
`;

const TextStyled = styled(Text)`
  padding: 0 20px 0px 20px;
`;

const Container = styled.div`
  height: 100%;
  width: 100%;
  max-width: 520px;
  margin: auto;
  .buttonContainer {
    margin: 0 auto 5px;
    max-width: 180px;
  }
  .inputContainer {
    padding: 0 20px 0px 20px;
    width: 100%;
  }
`;

const PhoneContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Prefix = styled.span`
  background-color: ${T.gray};
  padding: 0 10px;
  height: 40px;
  display: flex;
  align-items: center;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border: 1px solid ${T.gray};
  border-right: none;
`;

const InputStyledPhone = styled.input`
  width: 100%;
  height: 40px;
  border: 1px solid ${T.gray};
  border-radius: 5px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding: 0 10px;
  font-size: 16px;
  outline: none;
  margin: 10px auto;
  &:focus {
    border: 1px solid ${T.blue};
  }
`;

const InputStyled = styled.input`
  width: 100%;
  height: 40px;
  border: 1px solid ${T.gray};
  border-radius: 5px;
  padding: 0 10px;
  font-size: 16px;
  outline: none;
  margin: 10px auto;
  &:focus {
    border: 1px solid ${T.blue};
  }
`;

const SkipStyled = styled.span`
  font-size: 16px;
  color: black;

  &:hover {
    text-decoration: underline;
    cursor: pointer;
    color: ${T.blue}
  }
`;

const SkipContainer = styled.div`
  margin: 0 auto 10px;
  max-width: 40px;
  padding: 0;
  align-items: center;
}
`;
